import { render } from "./TeamDisplayDraft.vue?vue&type=template&id=2c7a5d9a&scoped=true"
import script from "./TeamDisplayDraft.vue?vue&type=script&lang=js"
export * from "./TeamDisplayDraft.vue?vue&type=script&lang=js"

import "./TeamDisplayDraft.vue?vue&type=style&index=0&id=2c7a5d9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7a5d9a"]])

export default __exports__